module.exports = __webpack_public_path__ + "static/media/menu.a8e5587e.png";